import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, Form, FormGroup, FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChannelService } from './channel.component.service';
import { ICreateChannel } from './interfaces/create-channel.interface';
import { IUpdateChannel } from './interfaces/update-channel.interface';
import ChannelAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/channel/channel.entity';
import CompanyAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity';
import { CompanyService } from '../company/company.service.service';
import { MatTabsModule } from '@angular/material/tabs';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { getCode } from "app/utils/method";
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FormSectionComponent } from 'app/shared/components/form-ui/form-section/form-section.component';


@Component({
  selector: 'app-channel',
  templateUrl: './channel.component.html',
  styleUrl: './channel.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    FilterComponent,
    ConfigurationFiltersComponent,
    StatusFiltersComponent,
    HoverMenuDirective,
    FormSectionComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class ChannelComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = ["name", "status", "actions"];
  currentCreateChannel: ICreateChannel = this.initializeCreateChannel();
  currentUpdateChannel: ChannelAttributes | undefined;

  dataSource: ChannelAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  searchQuery: string = '';
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;
  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;
  
  //BUSCADOR
  searchSubscription: Subscription;
  form: FormGroup;
  selectedStatuses: number[] = [1, 0]; // Default to Active and Inactive

  // Lazy loading
  loadFiltersData = false;
  private companiesLoaded = false;

  constructor(
    private readonly channelService: ChannelService,
    private companyService: CompanyService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      companyId: [],
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchAllCompanies();
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
  }


  private fetchAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
        this.companiesLoaded = true;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error fetching companies","Cerrar",{ duration: 5000});
      },
    });
  }


  private initializeCreateChannel(): ICreateChannel {
    return { name: "" , companyId: "" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  onClearFilter() {
    this.form.reset({
      companyId: null,
    });
    this.findAllWithCount();
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";

    let filter: IFilters = {
      companyId: this.form.get("companyId")?.value,
      status: this.selectedStatuses.length > 0 ? this.selectedStatuses : null,
    };
    this.channelService
      .findAllWithCount(
        { currentPage: pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection },
        filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof ChannelAttributes {
    const validSortFields: (keyof ChannelAttributes)[] = ["name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof ChannelAttributes) ? (this.sort.active as keyof ChannelAttributes) : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }
    
  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: ChannelAttributes): string {
    return item._id.toString();
  }

  openCreateModal(): void {
    this.ensureCompaniesLoaded();
    this.currentCreateChannel = this.initializeCreateChannel();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      disableClose: true,
      width: '95%',
      maxWidth: '600px',
      maxHeight: '90vh'
    })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createChannel());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(tenant: ChannelAttributes): void {
    this.ensureCompaniesLoaded();
    this.currentUpdateChannel = { ...tenant };
    this.dialogRefEdit = this.dialog.open(this.editModal, {
      disableClose: true,
      width: '95%',
      maxWidth: '600px',
      maxHeight: '90vh'
    })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateChannel(tenant._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createChannel(): void {
    this.channelService.create(this.currentCreateChannel).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
        this.dialogRefAdd.close(true);
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateChannel(id: string): void {
    if (this.currentUpdateChannel) {
      const updatedChannel: IUpdateChannel = { ...this.currentUpdateChannel,
        companyId: this.currentUpdateChannel.company._id.toString(),
       };

      this.channelService.update(id, updatedChannel).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close(true);
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, tenant: ChannelAttributes): void {
    const originalStatusId = tenant.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedChannel = { ...tenant, statusId: updatedStatusId };

    this.channelService.update(tenant._id.toString(), updatedChannel).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        tenant.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(tenant: ChannelAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: tenant, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(tenant._id.toString()));
  }

  delete(id: string): void {
    this.channelService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  
  onCompanySelectionChange(companyId: string): void {
    if (this.currentUpdateChannel) {
      this.currentUpdateChannel.company = this.companyList.find(
        (company) => company._id.toString() === companyId
      )!;
    }
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
